import type { IKeyword } from '@/assets/types/api/Products';
import type { ISearchItem } from '@/assets/types/api/Search';

export const useSearchMenuStore = defineStore('searchMenuStore', () => {
  const nuxtApp = useNuxtApp();

  /* State */

  const searchValue = ref<string>('');
  const searchResults = ref<ISearchItem[]>([]);
  const popularKeywords = ref<IKeyword[]>([]);
  const isMenuOpen = ref<boolean>(false);

  /* Actions */

  const USE_GET_SEARCH = async () => {
    /**
     * 全站搜尋（Client Only）
     */
    const { $i18n, $notification } = nuxtApp;
    const { locale } = $i18n;

    const query = computed(() => ({
      keyword: searchValue.value.trim(),
      websiteCode: locale.value,
    }));

    return await useCustomFetch(() => '/marketplace/api/v1/search', {
      method: 'GET',
      server: false,
      watch: false,
      query,
      lazy: true,
      immediate: false,
      onResponse: ({ response }) => {
        const { _data, status } = response;
        const data = _data as { items: ISearchItem[] };

        if (status >= 200 && status < 300) {
          searchResults.value = [...data.items];
        } else {
          console.error(_data);
          $notification({
            message: (_data as { message: string }).message,
            type: 'error',
          });
        }
      },
    });
  };

  const GET_POPULAR_KEYWORDS = async (): Promise<void> => {
    /**
     * 取得產品的熱門關鍵字資訊
     */
    const { $i18n, $customFetch, $notification } = nuxtApp;
    const { locale } = $i18n;

    try {
      const data = await $customFetch<IKeyword[]>(
        `/marketplace/api/v1/products/popular-keywords?websiteCode=${locale.value}`,
        { method: 'GET' }
      );
      popularKeywords.value = [...data];
    } catch (error) {
      $notification({
        message: (error as { message: string }).message,
        type: 'error',
      });
    }
  };

  const HANDLE_CLOSE_MENU = (): void => {
    /**
     * 關閉 MENU 視窗
     */
    isMenuOpen.value = false;
    searchValue.value = '';
  };

  return {
    searchValue,
    searchResults,
    popularKeywords,
    isMenuOpen,
    USE_GET_SEARCH,
    GET_POPULAR_KEYWORDS,
    HANDLE_CLOSE_MENU,
  };
});
